export default function translate(i18n, propriete) {
  if (propriete === 'code') return i18n.t('addEditPlanMedia.information.code');
  if (propriete === 'statut') return i18n.t('addEditPlanMedia.information.statut');
  if (propriete === 'gestionnaireId') return i18n.t('addEditPlanMedia.information.gestionnaire');
  if (propriete === 'dateFin') return i18n.t('addEditPlanMedia.information.dateFin');
  if (propriete === 'dateDebut') return i18n.t('addEditPlanMedia.information.dateDebut');
  if (propriete === 'commercialId') return i18n.t('addEditPlanMedia.information.gestionnaire');
  if (propriete.startsWith('evenements')) {
    const prefixI18n = 'addEditPlanMedia.evenement.error.';
    if (propriete.endsWith('DateEvenement')) return i18n.t(`${prefixI18n}dateEvenement`);
    if (propriete.endsWith('TypeId')) return i18n.t(`${prefixI18n}type`);
    if (propriete.endsWith('GestionnaireId')) return i18n.t(`${prefixI18n}gestionnaire`);
  }
  if (propriete.startsWith('commissions')) {
    if (propriete.endsWith('CommercialId')) return i18n.t('addEditPlanMedia.commissions.tab.commercial');
  }
  return propriete;
}
